import React from 'react'
import ChartLine from '../../Components/ChartLine'
import { getSaleChannelOverviewCharts } from 'Services/Analytics/saleChannel-analytics'

const ChartRow4 = () => {
  return (
    <>
      <div className="bg-white p-4 col-span-1">
        <div className="mb-4 font-semibold"> % Discount</div>
        <div className="w-full overflow-auto">
          <ChartLine
            chartCode="discount_ratio"
            handleDataFunction={getSaleChannelOverviewCharts}
            isHalf
          />
        </div>
      </div>
      <div className="bg-white p-4 col-span-1">
        <div className="mb-4 font-semibold"> Orders</div>
        <div className="w-full overflow-auto">
          <ChartLine chartCode="orders" handleDataFunction={getSaleChannelOverviewCharts} isHalf />
        </div>
      </div>
    </>
  )
}

export default ChartRow4
